import service from '@/api'
import { get, post } from '@/api/index'

/**
 *  推荐模块，搜索接口 话术
 *  奥迪专用
 */
export const test = params => {
  return service.post(
    '/knowledge-content-management/v1/content/new/rank/list',
    params
  )
}
// api/private/user/passenger/v1/list
export const getUserInfo = params => {
  const url = '/esocial/wxmp/' + params.appId + '/userinfo?code=' + params.code
  return service.get(url, params)
}
// https://tadmin.astro.saic-audi.mobi/iov-cms/koa/api/config/get
export const nhlogin = params => {
  return get('https://ecapi.yinmakeji.com/api/h5app/wxapp/nhlogin', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/personal 获取个人信息
export const personalInfo = params => {
  return get('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/personal', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/personal
export const savePerson = params => {
  return post('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/personal', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/user/getUserCardList
export const getUserCardList = params => {
  return get('https://ecapi.yinmakeji.com/api/h5app/wxapp/user/getUserCardList', params)
}
